import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import { svgSizeStyles } from '@/utils/styles';

export const SKILL_REVIEW_ACTION_CLASSES = {
  root: cn(
    svgSizeStyles(2),
    'p-0 label-02 mt-auto opacity-0 text-text-placeholder hover:text-text-white group-hover:opacity-100 focus-visible:text-text-white focus-visible:opacity-100 transition',
  ),
};

export const mtAuto = css`
  & > *:first-child {
    margin-top: auto;
  }
`;
